import { Component, OnInit } from '@angular/core';
import { SeoService } from '../../service/seo.service';

@Component({
  selector: 'app-who',
  templateUrl: './who.component.html',
  styles: [],
  standalone: false
})
export class WhoComponent implements OnInit {

  constructor(private seo: SeoService) { }

  hover = -1

  ngOnInit(): void {
    this.seo.updateSeo({
      titleSeo: "Chi Siamo | Innovation Plaza Consulenza Innovazione",
      metadescription: 'Innovation Plaza è una società di consulenza che supporta imprese e istituzioni nello sviluppo di progetti innovativi e accesso ai fondi pubblici.',
      url: 'https://innovationplaza.it/chi-siamo',
      jsonLd: [
        {
          "@context": "https://schema.org",
          "@type": "AboutPage",
          "@id": "https://innovationplaza.it/chi-siamo/#webpage",
          "url": "https://innovationplaza.it/chi-siamo/",
          "name": "Chi Siamo Innovation Plaza",
          "inLanguage": "it-IT",
          "isPartOf": { "@id": "https://innovationplaza.it/#website" },
          "about": { "@id": "https://innovationplaza.it/#organization" }
        },
        {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://innovationplaza.it/" },
            { "@type": "ListItem", "position": 2, "name": "Chi Siamo", "item": "https://innovationplaza.it/chi-siamo/" }
          ]
        }
      ]
    });
  }
}
